// Utility functions for converting different types of data into a readable format

export function gradeToString(grade: number): string {
  if (grade === 0) {
    return "K";
  }
  return grade.toString();
}
